export const LoadingRing = () => {
	return (
		<div className="w-full h-full rounded-full animate-spin border-2 border-solid border-black border-t-transparent"></div>
	);
};
